angular
    .module('vm')
    .component('appVmcPromoAlert', {
        templateUrl: 'vmc-promo-alert.component.html',
        bindings: {
            country: '=',
        },
        controllerAs: 'vm',
        controller: function () {
            var vm = this;
        }
    })
;